import React, { Component, Fragment, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { withRouter } from "react-router-dom";
import SessionStyles from "../styles/Session";
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import IconButton from "@material-ui/core/IconButton";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import Image1 from "../images/art1.jpeg";
import Image2 from "../images/art2.jpeg";
import Image3 from "../images/art3.jpeg";
import Fab from "@material-ui/core/Fab";
import Typography from "@material-ui/core/Typography";
import Lightbox from "react-image-lightbox";
import DownloadIcon from "@material-ui/icons/GetAppTwoTone";
import PdfLogo from './Images/pdfLogo.png';
import "react-image-lightbox/style.css";
import Webcam from "react-webcam";
import Button from "@material-ui/core/Button";

const moment = require("moment");

const styles = theme => ({
  titleBar: {
    background:
      "linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, " +
      "rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)"
  },
  icon: {
    color: "white"
  },
  title: {
    fontSize: 12
  }
});

export const getPDFBase64 = file => new Promise((resolve, reject) => {
  console.log("getBase64 file: ", file);

  let reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function(r){
  console.log("r", r)
  resolve(r.target.result);
  }
  reader.onerror = (error) => reject(error);
});

function getBase64(file) {
  return new Promise((resolve, reject) => {
    var image, oldWidth, oldHeight, newHeight, canvas, ctx, newDataUrl;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      var img = new Image();
      img.onload = function() {
        const imageType = file.type || "image/jpeg";
        const imageArguments = 0.5;

        // Create a temporary image so that we can compute the height of the downscaled image.
        image = new Image();
        image.src = reader.result;
        oldWidth = image.width;
        oldHeight = image.height;
        const newWidth = oldWidth / 2;
        newHeight = Math.floor((oldHeight / oldWidth) * newWidth);

        // Create a temporary canvas to draw the downscaled image on.
        canvas = document.createElement("canvas");
        canvas.width = newWidth;
        canvas.height = newHeight;

        // Draw the downscaled image on the canvas and return the new data URL.
        ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, newWidth, newHeight);
        newDataUrl = canvas.toDataURL(imageType, imageArguments);
        resolve(newDataUrl);
      };
      img.src = reader.result;
    };
    reader.onerror = error => reject(error);
  });
}

const videoConstraints = {
  width: 1280,
  height: 720,
  facingMode: "user"
};

class ImageGallery extends Component {
  constructor(props) {
    super(props);
    this.webcamRef = React.createRef();
    this.state = {
      isCamera: false,
      images: [{}],
      multiple: true,
      isOpen: false,
      photoIndex: 0
    };
  }

  render() {
    // const webcamRef = React.useRef(null);
    const { classes, disableAdd, photos } = this.props;
    const { isCamera, photoIndex, isOpen } = this.state;
    //console.log("photos = ", photos);
    
    return (
      <Fragment>
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          style={{ padding: 5 }}
        >
          <Grid item xs={7}>
            <GridList cellHeight={120} spacing={6} cols={2}>
           {/* { console.log("photos =>>> ", photos) } */}
              {photos ? (
                photos.map((r, index) => (
                  
                  <GridListTile key={r.id}>
                    <img
                      src={r.type === "PDF" ? PdfLogo : r.url}
                      alt="image"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.setState({ isOpen: true, photoIndex: index });
                      }}
                    />
                    <GridListTileBar
                      titlePosition="top"
                      // className={classes.titleBar}
                      classes={{
                        root: classes.titleBar,
                        title: classes.title
                      }}
                      // style={{ cursor: 'pointer' }}
                      // onClick={() => { this.setState({ isOpen: true }) }}
                      title={moment(r.photodatetime__c).format("DD-MM-YY")}
                      actionIcon={
                        <IconButton
                          className={classes.icon}
                          style={{ padding: 1 }}
                          onClick={() => this.props.delete(r.id)}
                        >
                          <DeleteForeverIcon style={{ color: "white" }} />
                        </IconButton>
                      }
                    />
                  </GridListTile>
                ))
              ) : (
                <Typography align="center" variant="caption">
                  Please Upload
                </Typography>
              )}
            </GridList>
          </Grid>
          <Grid item xs={2}>
            {photos && photos[0] && photos[0].url ?
              <Fab
                size="small"
                color="secondary"
              >
                <DownloadIcon
                  style={{ fontSize: "28px" }}
                  onClick={() => window.open(photos[0].url, "_self")}
                />
              </Fab>
              : null
            }
          </Grid>
          <Grid item xs={2}>
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="center"
            >
              {disableAdd ? null : (
                <div id="photopload">
                  <Fab
                    size="small"
                    onClick={() => this.fileUpload.click()}
                    color="secondary"
                  >
                    <AddAPhotoIcon />
                  </Fab>
                </div>
              )}
            </Grid>
          </Grid>
          {/* Add Camera */}
          <Grid item xs={1}>
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="center"
            >
              {disableAdd ? null : (
                <div id="photopload">
                  <Fab
                    size="small"
                    onClick={() => this.setState({isCamera: true})}
                    color="secondary"
                  >
                    <PhotoCameraIcon />
                  </Fab>
                </div>
              )}
            </Grid>
          </Grid>
        </Grid>
        
        <Grid container>
          <input
            type="file"
            ref={fileUpload => {
              this.fileUpload = fileUpload;
            }}
            multiple
            style={{ visibility: "hidden" }}
            onChange={e => {
              const file = e.target.files;
              const filesArray = Array.from(file);

              console.log("file = ", file, filesArray)
              // if(file.type === "image/jpeg"){
              filesArray.map((item)=>{
                  if (item.type.includes("image") ){
                    getBase64(item).then(r => {
                      this.props.upload({
                        document: r,
                        id: item.name,
                        type: item.type,
                        lastModifiedDate: item.lastModifiedDate
                      });
                    });
                  }
                  else{
                    getPDFBase64(item).then(r => {
                      this.props.upload({
                        document: r,
                        id: item.name,
                        type: item.type,
                        lastModifiedDate: item.lastModifiedDate
                      });
                    });
                  }
                })
            }}
          />
        </Grid>
        <Grid container justify="center" alignItems="center">
          {isOpen && (
            <Lightbox
              mainSrc={photos[photoIndex].url}
              nextSrc={
                photos[(photoIndex + 1) % photos.length]
                  .url
              }
              prevSrc={
                photos[
                  (photoIndex + photos.length - 1) %
                    photos.length
                ].url
              }
              onCloseRequest={() => this.setState({ isOpen: false })}
              onMovePrevRequest={() =>
                this.setState({
                  photoIndex:
                    (photoIndex + photos.length - 1) %
                    photos.length
                })
              }
              onMoveNextRequest={() =>
                this.setState({
                  photoIndex: (photoIndex + 1) % photos.length
                })
              }
              imageCaption={photos[photoIndex].photodatetime__c}
              // imageTitle={"Image " + photoIndex + " Address goes here"}
            />
          )}
        </Grid>
        <Grid container justify="center" alignItems="center">
          {isCamera && (
            <div>
              <Webcam
                audio={false}
                height={360}
                ref={this.webcamRef}
                screenshotFormat="image/jpeg"
                width={640}
                videoConstraints={videoConstraints}
                />
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  className={classes.button}
                  onClick={e => {
                    e.preventDefault();
                    this.setState({isCamera: false});
                    const imageSrc = this.webcamRef.current.getScreenshot();
                    console.log("imageSrc => " + imageSrc);

                    var newDate = new Date();

                    this.props.upload({
                      document: imageSrc,
                      id: "Captured",
                      type: "image/jpeg",
                      lastModifiedDate: newDate
                    });
                    
                  }}
                >
                  Capture
                </Button>
              </div>
          )}
        </Grid>
      </Fragment>
    );
  }
}

export default withRouter(withStyles(styles)(ImageGallery));